export const fragments_config = {
   COLUMNS: 50,
   ROWS: 10,
   ICON_SIZE: 7,
   COLOR: "#ffffff",
   LETTER_DIM: 7,
   TEXT_FILLER: " ",
   LETTERS_MARGIN: 2,
};

export const phone_fragments_config = {
   COLUMNS: 5,
   ROWS: 10,
   ICON_SIZE: 25,
   LETTER_DIM: 5,
   TEXT_FILLER: " ",
   LETTERS_MARGIN: 1,
};

